import { render, staticRenderFns } from "./ChangeAccount.vue?vue&type=template&id=3b636c58&"
import script from "./ChangeAccount.vue?vue&type=script&lang=js&"
export * from "./ChangeAccount.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports